import { ApplicationState } from 'app/types-store';

export const selectContainerLayout = (dashboardType: number) => (state: ApplicationState) =>
  state.dashboard?.layouts?.[dashboardType]?.definition;

export const selectFetchingMainFavourite = (state: ApplicationState) =>
  state.dashboard?.fetchingMainFavourite;

export const selectMainFavouriteId = (state: ApplicationState) =>
  state.dashboard?.mainFavouriteId;

export const selectExecutionCounter = (state: ApplicationState) =>
  state.dashboard?.executionCounter;
